import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';

import { AppState } from '../store/';
import config from '../config';

import NotFound from '../containers/not-found';
import DocumentTypeMain from '../containers/document-type/screens/container';
import DocumentMain from '../containers/document/screens/container';
import EmailMain from '../containers/email/screens/container';
import ProductMain from '../containers/product/screens/container';

const PrivateRoutes: React.FC = () => {
  const authType: string = useSelector((state: AppState) => state.Authorization.authType);
  const {search} = useLocation();
  const query = new URLSearchParams(search);
  const token = query.get('token');

  const publicUrl = process.env.PUBLIC_URL;
  return (
    <Router basename={`${publicUrl}/?token=${token}`}>
      <Switch>
        <Route path={`/document-type/`} component={authType === config.userTypeAdmin ? DocumentTypeMain : NotFound } />
        <Route path={`/document/`} exact component={DocumentMain} />
        <Route path={`/document/:providerId`} component={DocumentMain} />
        <Route path={`/product/`} component={authType === config.userTypeAdmin ? ProductMain : NotFound } />
        <Route path={`/email/`} component={authType === config.userTypeAdmin ? EmailMain : NotFound } />
        <Route path={`/not-found`} exact component={NotFound} />
      </Switch>
    </Router>
  );
}

export default PrivateRoutes;
